var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "input-box" },
    [
      _vm.label !== null
        ? _c("label", { staticClass: "label-text" }, [
            _vm._v(_vm._s(_vm.label)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("validation-provider", {
        ref: "validationInput",
        attrs: { name: "baseInputEditValidationProvider", rules: _vm.rules },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var errors = ref.errors
              var valid = ref.valid
              return [
                _c(
                  "div",
                  {
                    staticClass: "form-group",
                    class: errors.length > 0 ? "error" : "",
                  },
                  [
                    _vm.type === "checkbox"
                      ? _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.displayModel,
                              expression: "displayModel",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: {
                            disabled: _vm.disabled,
                            autocomplete: "off",
                            name: "",
                            placeholder: "",
                            type: "checkbox",
                          },
                          domProps: {
                            checked: Array.isArray(_vm.displayModel)
                              ? _vm._i(_vm.displayModel, null) > -1
                              : _vm.displayModel,
                          },
                          on: {
                            change: function ($event) {
                              var $$a = _vm.displayModel,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.displayModel = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.displayModel = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.displayModel = $$c
                              }
                            },
                          },
                        })
                      : _vm.type === "radio"
                      ? _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.displayModel,
                              expression: "displayModel",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: {
                            disabled: _vm.disabled,
                            autocomplete: "off",
                            name: "",
                            placeholder: "",
                            type: "radio",
                          },
                          domProps: { checked: _vm._q(_vm.displayModel, null) },
                          on: {
                            change: function ($event) {
                              _vm.displayModel = null
                            },
                          },
                        })
                      : _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.displayModel,
                              expression: "displayModel",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: {
                            disabled: _vm.disabled,
                            autocomplete: "off",
                            name: "",
                            placeholder: "",
                            type: _vm.type,
                          },
                          domProps: { value: _vm.displayModel },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.displayModel = $event.target.value
                            },
                          },
                        }),
                    _vm._v(" "),
                    _c("small", { staticClass: "error-text" }, [
                      _vm._v(_vm._s(errors[0])),
                    ]),
                  ]
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }